import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { PreloadCacheProvider } from 'framework/context/PreloadCacheProvider';
import { ListFilterComponent } from 'framework/filter/ListFilterComponent';
import { usePreloadCacheContext } from 'framework/hooks/usePreloadCacheContext';
import { IUsersCache, IUserSummary, usersQuery_all, usersQuery_concurrencyToken } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useContext } from 'react';
import { PreloadContext } from 'shared/context/PreloadContext';

export const UsersCacheContext = React.createContext<IPreloadCacheContext<IUsersCache>>(undefined as any);

export const UsersCacheProvider = ({ children }: any) => {
	const { usersCache } = useContext(PreloadContext);

	return (
		<PreloadCacheProvider<IUsersCache>
			concurrencyF={usersQuery_concurrencyToken}
			loadF={usersQuery_all}
			context={UsersCacheContext}
			initialData={usersCache}>
			{children}
		</PreloadCacheProvider>
	);
};

type UseUsersDataOptions = {
	includeBlocked?: boolean;
	onlyAudiologists?: boolean;
};

export function useUsersData({ includeBlocked, onlyAudiologists }: UseUsersDataOptions): IUserSummary[] {
	const [usersCache] = usePreloadCacheContext(UsersCacheContext);
	const fUsers = usersCache.users
		.filter(t => includeBlocked === true || t.blocked === false)
		.filter(t => (onlyAudiologists === true ? t.isAudiologist : true))
		.map(t => ({ ...t, identifier: t.lastNameCommaFirstName ?? '' }));

	return fUsers;
}

// export interface IUserOption extends IOption<string> {
// 	isAudiologist: boolean;
// }

// export const useUsersAsFilterOptions = (): IUserOption[] => {
// 	const [usersCache] = usePreloadCacheContext(UsersCacheContext);
// 	return React.useMemo(
// 		() => usersCache.users.map<IUserOption>(t => ({ id: t.id, identifier: t.lastNameCommaFirstName ?? '', isAudiologist: t.isAudiologist })),
// 		[usersCache]
// 	);
// };

type FilterUsersProps = {
	value: string[];
	onChange: (val: string[]) => void;
	options: UseUsersDataOptions;
	label?: string;
	title?: string;
};

export const FilterUsers = ({ value, onChange, options, label, title }: FilterUsersProps) => {
	const users = useUsersData(options);
	const strings = useLocalization();

	return (
		<ListFilterComponent<string>
			options={users}
			selected={value}
			setSelected={vals => onChange(vals)}
			label={label ?? strings.user}
			icon={<HelpOutlineIcon />}
			title={title ?? strings.user}
		/>
	);
};
